/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowFigureACircleLeftIcon16Light } from './ArrowFigureACircleLeftIcon16Light';
import { ArrowFigureACircleLeftIcon16Regular } from './ArrowFigureACircleLeftIcon16Regular';
import { ArrowFigureACircleLeftIcon16Solid } from './ArrowFigureACircleLeftIcon16Solid';
import { ArrowFigureACircleLeftIcon20Light } from './ArrowFigureACircleLeftIcon20Light';
import { ArrowFigureACircleLeftIcon20Regular } from './ArrowFigureACircleLeftIcon20Regular';
import { ArrowFigureACircleLeftIcon20Solid } from './ArrowFigureACircleLeftIcon20Solid';
import { ArrowFigureACircleLeftIcon24Regular } from './ArrowFigureACircleLeftIcon24Regular';
import { ArrowFigureACircleLeftIcon24Solid } from './ArrowFigureACircleLeftIcon24Solid';
import { ArrowFigureACircleLeftIcon32Regular } from './ArrowFigureACircleLeftIcon32Regular';
import { ArrowFigureACircleLeftIcon64Regular } from './ArrowFigureACircleLeftIcon64Regular';
var sizes = {
    16: {
        light: ArrowFigureACircleLeftIcon16Light,
        regular: ArrowFigureACircleLeftIcon16Regular,
        solid: ArrowFigureACircleLeftIcon16Solid,
    },
    20: {
        light: ArrowFigureACircleLeftIcon20Light,
        regular: ArrowFigureACircleLeftIcon20Regular,
        solid: ArrowFigureACircleLeftIcon20Solid,
    },
    24: {
        regular: ArrowFigureACircleLeftIcon24Regular,
        solid: ArrowFigureACircleLeftIcon24Solid,
    },
    32: {
        regular: ArrowFigureACircleLeftIcon32Regular,
    },
    64: {
        regular: ArrowFigureACircleLeftIcon64Regular,
    },
};
export var ArrowFigureACircleLeftIcon = forwardRef('ArrowFigureACircleLeftIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
